import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/auth';
import {
  HiOutlineCog6Tooth,
  HiOutlineBell,
  HiOutlineChevronDown,
  HiOutlineUserCircle,
  HiOutlineLogout,
} from './Icons';
import './TopHeader.css';

export default function TopHeader() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Get username from localStorage (stored during login)
    const storedUsername = localStorage.getItem('username') || 'User';
    setUsername(storedUsername);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <header className="top-header">
      <div className="top-header-content">
        <div className="top-header-left">
          {/* Can add breadcrumbs or page title here later */}
        </div>

        <div className="top-header-right">
          {/* Quick Actions */}
          <div className="header-actions">
            <button
              className="header-action-btn"
              onClick={() => navigate('/logs')}
              title="View Recent Activity"
              aria-label="View Recent Activity"
            >
              <HiOutlineBell size={20} />
              <span className="action-label">Activity</span>
            </button>
          </div>

          {/* User Profile Dropdown */}
          <div className="user-menu" ref={dropdownRef}>
            <button
              className="user-menu-trigger"
              onClick={() => setShowDropdown(!showDropdown)}
              aria-label="User menu"
            >
              <div className="user-avatar">
                {getInitials(username)}
              </div>
              <div className="user-info">
                <span className="user-name">{username}</span>
                <span className="user-role">Administrator</span>
              </div>
              <HiOutlineChevronDown 
                size={16} 
                className={`dropdown-icon ${showDropdown ? 'open' : ''}`}
              />
            </button>

            {showDropdown && (
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="dropdown-avatar">
                    {getInitials(username)}
                  </div>
                  <div className="dropdown-user-info">
                    <div className="dropdown-name">{username}</div>
                    <div className="dropdown-email">admin@aixcellence.com</div>
                  </div>
                </div>

                <div className="dropdown-divider"></div>

                <div className="dropdown-menu">
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setShowDropdown(false);
                      // Navigate to profile/settings when implemented
                      // navigate('/settings');
                    }}
                  >
                    <HiOutlineUserCircle size={18} />
                    <span>Profile</span>
                  </button>

                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setShowDropdown(false);
                      // Navigate to settings when implemented
                      // navigate('/settings');
                    }}
                  >
                    <HiOutlineCog6Tooth size={18} />
                    <span>Settings</span>
                  </button>

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item dropdown-item-danger"
                    onClick={handleLogout}
                  >
                    <HiOutlineLogout size={18} />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

